/**
 * 历史遗留问题：给固定页面使用
 */
import axios from 'axios'
import qs from 'qs'
import { business } from '@xes/trade-toolkit'

axios.defaults.withCredentials = true
let CancelToken = axios.CancelToken

//bizid 默认素质
const bizSettiings = business.getCurrentBizKeyValueObject()

// 拦截request,设置全局请求为ajax请求
axios.interceptors.request.use(function (config) {
  config.headers['X-Requested-With'] = 'XMLHttpRequest'
  config.timeout = 30000 // 超时时间
  let cancelGroupName
  // 追加bizid
  if (config.method === 'get') {
    config.params = config.params || {}
    config.params = {
      ...config.params,
      ...bizSettiings
    }
  } else if (config.method === 'post') {
    config.data = config.data || {}
    config.data = {
      ...config.data,
      ...bizSettiings
    }
  }

  if (config.method === 'post') {
    if (config.data && config.data.cancelGroupName) {
      // post请求ajax取消函数配置
      cancelGroupName = config.data.cancelGroupName
    }
    config.data = qs.stringify(config.data)
  } else {
    if (config.params && config.params.cancelGroupName) {
      // get请求ajax取消函数配置
      cancelGroupName = config.params.cancelGroupName
    }
  }
  if (cancelGroupName) {
    if (axios[cancelGroupName] && axios[cancelGroupName].cancel) {
      axios[cancelGroupName].cancel()
    }
    config.cancelToken = new CancelToken(c => {
      axios[cancelGroupName] = {}
      axios[cancelGroupName].cancel = c
    })
  }
  return config
})

// 拦截响应response，并做一些错误处理
axios.interceptors.response.use(
  function (response) {
    const data = response.data
    // 根据返回的code值来做不同的处理（和后端约定）
    if (data.stat === 9) {
      console.log(process.env)
      if (process.env.NODE_ENV !== 'development') {
        const URL = window.location.href
        if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
          const url = encodeURIComponent(URL)
          const loginUrl = encodeURIComponent(`https://login.xueersi.com/?from=touch&redirect_url=${encodeURIComponent(url)}`)
          window.location.href = `https://login.xueersi.com/newLogin/logout/?redirect_url=${encodeURIComponent(loginUrl)}`
        } else {
          window.location.replace(`https://login.xueersi.com/?from=touch&redirect_url=${encodeURIComponent(URL)}`)
        }
      }
    }
    return data
  },

  function (err) {
    // 这里是返回状态码不为200时候的错误处理
    if (err.code == 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
      // 超时处理
      window.x5home_dialogVisible = true
    }
    return Promise.reject(err)
  }
)
export default axios



// WEBPACK FOOTER //
// ./common/assets/js/ocenter-axios.js